<template>
    <card class="mb-5">
        <template slot="body">
            <form @submit.prevent="save" >
                <template>
                    <div v-if="!editable" @click="toggleEdit" class="btn btn-link btn-sm text-blue float-right">
                        <i class="fa fa-edit"></i> Edit
                    </div>
                    <div v-if="editable && !isRequesting" @click="toggleEdit" class="btn btn-link btn-sm text-danger float-right">
                        <i class="fa fa-ban"></i> Cancel
                    </div>
                </template>
                <h6 class="heading-small text-muted">Personal Information</h6>
                <div class="row" v-if="!editable">
                    <div class="col-lg-6">
                        <div class="text-xs">First Name</div>
                        <h3 class="font-weight-700 text-default text-sm" v-text="user.firstname"></h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Middle Name</div>
                        <h3 class="font-weight-700 text-default text-sm" v-text="user.middlename"></h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Last Name</div>
                        <h3 class="font-weight-700 text-default text-sm" v-text="user.lastname"></h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Suffix</div>
                        <h3  v-if="user.suffix" class="font-weight-700 text-default text-sm" v-text="user.suffix"></h3>
                        <h3 v-else class="font-weight-700 text-default text-sm text-muted">None</h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Sex</div>
                        <h3  v-if="user.gender" class="font-weight-700 text-default text-sm text-capitalize" v-text="user.gender"></h3>
                        <h3 v-else class="font-weight-700 text-default text-sm text-muted">None</h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Birthdate</div>
                        <h3 class="font-weight-700 text-default text-sm" v-text="displayedBirthdate"></h3>
                    </div>
                    <div class="col-lg-6">
                        <div class="text-xs">Mobile No.</div>
                        <h3 class="font-weight-700 text-default text-sm" v-text="user.contact_no"></h3>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-lg-7">
                        <form-input
                            placeholder="First Name"
                            label="First Name"
                            v-model="form.firstname"
                            ref="firstname"
                        ></form-input>
                    </div>
                    <div class="col-lg-5">
                        <form-input
                            placeholder="Middle Name"
                            label="Middle Name"
                            v-model="form.middlename"
                            ref="middlename"
                        ></form-input>
                    </div>
                    <div class="col-lg-7">
                        <form-input
                            placeholder="Last Name"
                            label="Last Name"
                            v-model="form.lastname"
                            ref="lastname"
                        ></form-input>
                    </div>
                    <div class="col-lg-5">
                        <form-input
                            placeholder="Suffix"
                            label="Suffix"
                            v-model="form.suffix"
                            ref="suffix"
                        ></form-input>
                    </div>
                    <div class="col-lg-4">
                        <form-select
                            :options="genders"
                            label="Sex"
                            placeholder="Sex"
                            v-model="form.gender"
                            ref="gender"
                            allow-empty
                        >
                        </form-select>
                    </div>
                    <div class="col-lg-6">
                        <form-date-picker
                            label="Birthdate"
                            format="MMMM DD, YYYY"
                            v-model="form.birthdate"
                            ref="birthdate"
                            max-date="today"
                        ></form-date-picker>
                    </div>
                    <div class="col-lg-6">
                        <form-input
                            label="Mobile No."
                            placeholder="13-digit mobile no"
                            v-model="form.contact_no"
                            ref="contact_no"
                            :mask="['+639#########']"
                        ></form-input>
                    </div>
                    <div class="col-12 text-right">
                        <button v-if="!isRequesting" type="submit" class="btn btn-warning long">
                            <i class="fa fa-save mr-1"></i> Save
                        </button>
                        <button v-else type="button" disabled class="disabled btn btn-warning long">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Please wait
                        </button>
                    </div>
                </div>
            </form>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import moment from "moment";
import Form from "@models/components/Form";

export default {
    name: "ProfileSection",

    computed: {
        displayedBirthdate() {
            return moment(this.user.birthdate).format("MMMM DD, YYYY");
        },
        user() {
            return this.$store.getters.user || {};
        },
    },

    data() {
        return {
            genders: this.formatOptions(["male", "female"]),
            editable: false,
            isRequesting: false,
            form: {
                lastname: "",
                suffix: "",
                firstname: "",
                middlename: "",
                gender: "male",
                birthdate: moment().format("MMMM DD, YYYY"),
                contact_no: "",
                prefix: "",
            },
        };
    },

    methods: {
        toggleEdit() {
            (this.editable = !this.editable)
                ? null
                : this.form.resetData();
        },
        
        initializeUser() {
            this.form = new Form({
                lastname: this.user.lastname,
                suffix: this.user.suffix,
                prefix: this.user.prefix,
                firstname: this.user.firstname,
                middlename: this.user.middlename,
                gender: this.user.gender,
                birthdate: moment(this.user.birthdate).format("MMMM DD, YYYY"),
                contact_no: this.user.contact_no,
                contact_id: this.user.contact_id,
            });
        },

        async save() {
            if (!(await this.confirm("Are you sure you want to save this data?", "")).value) {
                return;
            }
            this.isRequesting = true;
            this.$store.dispatch("updateProfile", { data: this.form.getData() })
                .then(response => this.saved(response))
                .catch(error => this.failedToSave(error))
                .finally(() => (this.isRequesting = false));
        },

        saved(response) {
            this.form.save();
            this.editable = false;
            this.promptMessage(response.data.message.message, "");
            this.$emit("updated", response.data.result.user);
        },

        failedToSave(error) {
            console.log(error);
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [mixins],
}
</script>